var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("ribbon"),
      _vm._v(" "),
      _c("div", { attrs: { id: "app-header" } }, [_c("jhi-navbar")], 1),
      _vm._v(" "),
      _c("b-colapse"),
      _vm._v(" "),
      _vm.authenticated
        ? _c("aside", [
            _c("h2"),
            _vm._v(" "),
            _c("form", [
              _c(
                "ul",
                { staticClass: "ListaGeneral" },
                _vm._l(_vm.menuItems, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.label,
                      class: {
                        selected: _vm.selectedItem === item.label,
                      },
                    },
                    [
                      _c(
                        "b-link",
                        {
                          attrs: {
                            to: item.link.startsWith("/")
                              ? item.link
                              : "/" + item.link,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.selectItem(item.label)
                            },
                          },
                        },
                        [
                          item.icon
                            ? _c(
                                "svg",
                                {
                                  class: "bi bi-" + item.icon,
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    viewBox: "0 0 16 16",
                                  },
                                },
                                [
                                  _c("path", { attrs: { d: item.path1 } }),
                                  _vm._v(" "),
                                  item.path2
                                    ? _c("path", { attrs: { d: item.path2 } })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.path3
                                    ? _c("path", { attrs: { d: item.path3 } })
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(
                            "\n\n              " +
                              _vm._s(item.label) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated
        ? _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _c(
                "div",
                {
                  staticClass: "card jh-card",
                  staticStyle: {
                    "overflow-y": "auto",
                    "/* height": "100px */",
                  },
                },
                [_c("router-view")],
                1
              ),
              _vm._v(" "),
              _c("jhi-footer"),
            ],
            1
          )
        : _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "card jh-card2" }, [_c("router-view")], 1),
          ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "login-page",
            "hide-footer": "",
            lazy: "",
            "dialog-class": "login-modal",
          },
        },
        [
          _c(
            "span",
            {
              attrs: {
                slot: "modal-title",
                "data-cy": "loginTitle",
                id: "login-title",
              },
              slot: "modal-title",
            },
            [_vm._v("Iniciar sesión")]
          ),
          _vm._v(" "),
          _c("login-form"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }